<template>
  <div>
    <mu-dialog
      title="查看图片"
      width="1200"
      :open="open"
      @close="close"
      class="view-dialog"
    >
      <mu-carousel
        :cycle="false"
        :active="active"
        hide-indicators
        @change="change"
      >
        <mu-icon
          value="navigate_before"
          slot="left"
          class="carousel-btn"
        ></mu-icon>
        <mu-icon
          value="navigate_next"
          slot="right"
          class="carousel-btn"
        ></mu-icon>
        <mu-carousel-item
          v-for="(item, index) in list"
          :key="index"
          class="carousel-item"
        >
          <img
            :src="item.url"
            :class="['carousel-img', imgClass]"
            @mousedown="mouseDown"
            :style="{
              left: left + 'px',
              top: top + 'px',
              transform: `rotate(${deg}deg)`
            }"
          />
          <div class="handler">
            <mu-icon
              value="replay"
              :size="40"
              class="btn"
              @click="leftRotate"
            ></mu-icon>
            <mu-icon
              value="refresh"
              :size="40"
              class="btn"
              @click="rightRotate"
            ></mu-icon>
          </div>
          <div class="title" v-if="item.title">{{ item.title }}</div>
        </mu-carousel-item>
      </mu-carousel>
    </mu-dialog>
  </div>
</template>

<script>
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    imageList: {
      type: Array
    },
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      zoom: 10,
      left: 0,
      top: 0,
      list: [],
      deg: 0
    }
  },
  methods: {
    close() {
      this.$emit('update:open', false)
    },
    mouseWheelHandler(e) {
      if (e.wheelDeltaY > 0) {
        if (this.zoom < 20) {
          this.zoom++
        }
      } else if (e.wheelDeltaY < 0) {
        if (this.zoom > 1) {
          this.zoom--
        }
      }
    },
    mouseDown(e) {
      e.stopPropagation()
      e.preventDefault()
      const startX = e.clientX
      const startY = e.clientY
      window.onmouseup = (e) => {
        const endX = e.clientX
        const endY = e.clientY
        this.left = endX - startX
        this.top = endY - startY
      }
    },
    change() {
      this.zoom = 10
      this.deg = 0
    },
    leftRotate() {
      this.deg -= 90
    },
    rightRotate() {
      this.deg += 90
    }
  },
  computed: {
    imgClass() {
      return 'img' + this.zoom
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.zoom = 10
        this.deg = 0
        const list = []
        window.addEventListener('mousewheel', this.mouseWheelHandler)
        this.imageList.forEach((item) => {
          if (typeof item === 'string') {
            list.push({
              title: '',
              url: item
            })
          } else {
            list.push(item)
          }
        })
        this.list = list
      } else {
        window.removeEventListener('mousewheel', this.mouseWheelHandler)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.view-dialog {
  .carousel-btn {
    color: #ff4081;
    font-size: 24px;
  }
  .carousel-item {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .title {
      position: absolute;
      bottom: 0;
      height: 30px;
      line-height: 30px;
      width: 100%;
      background: #757575;
      color: #fff;
      text-align: center;
    }
    .handler {
      position: absolute;
      bottom: 30px;
      width: 100%;
      text-align: center;
      display: none;
      .btn {
        cursor: pointer;
        &:nth-child(2) {
          margin-left: 20px;
        }
        &:hover {
          color: #ff4081;
        }
      }
    }
    &:hover {
      .handler {
        display: block;
      }
    }
    .carousel-img {
      display: block;
      position: relative;
      left: 0;
      top: 0;
      min-width: auto;
      transform: none;
      cursor: move;
      &.img1 {
        zoom: 0.1;
      }
      &.img2 {
        zoom: 0.2;
      }
      &.img3 {
        zoom: 0.3;
      }
      &.img4 {
        zoom: 0.4;
      }
      &.img5 {
        zoom: 0.5;
      }
      &.img6 {
        zoom: 0.6;
      }
      &.img7 {
        zoom: 0.7;
      }
      &.img8 {
        zoom: 0.8;
      }
      &.img9 {
        zoom: 0.9;
      }
      &.img10 {
        zoom: 1;
      }
      &.img11 {
        zoom: 1.1;
      }
      &.img12 {
        zoom: 1.2;
      }
      &.img13 {
        zoom: 1.3;
      }
      &.img14 {
        zoom: 1.4;
      }
      &.img15 {
        zoom: 1.5;
      }
      &.img16 {
        zoom: 1.6;
      }
      &.img17 {
        zoom: 1.7;
      }
      &.img18 {
        zoom: 1.8;
      }
      &.img19 {
        zoom: 1.9;
      }
      &.img20 {
        zoom: 2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/imageView/index.vue